import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { User } from '../_models';
import { AppConfig } from 'src/assets/config/config/app-config';

@Injectable({ providedIn: 'root' })
export class UserService {
    apiUrl:string

    constructor(private http: HttpClient,
        private config:AppConfig) { 
            this.apiUrl=this.config.getConfig("apiUrl")
        }

    getAll() {
        return this.http.get<User[]>(this.apiUrl+`/usergroups/all`);
    }

    register(user: User) {
        return this.http.post(this.apiUrl+`/users/register`, user);
    }

    delete(id: number) {
        return this.http.delete(this.apiUrl+`/users/${id}`);
    }
}